<template>
    <div class="error-msg-wrap">
        <div class="form-wrapper slide-up" style="width:480px">
            <div class="form-close">
                <button type="button" class="form-close-x" title="Close" @click="$emit('close')">&times;</button>
            </div>
            <h2 class="sb-modal-title">Remind {{ teamLabel(team) }}</h2>

            <p v-if="!loaded" class="sb-intro">Loading&hellip;</p>
            <template v-else>
                <p class="sb-intro">{{ texted.length ? 'Each person gets a text listing the numbers they still need to enter this week.' : 'There\'s no one to text.' }}</p>

                <div v-for="r in recipients" :key="r.EmployeeID" class="sb-nudge-row">
                    <div class="sb-nudge-l">
                        <b>{{ r.Name }}</b>
                        <span>{{ r.Metrics.join(', ') }}</span>
                    </div>
                    <span v-if="r.HasPhone" class="sb-nudge-ok">Text</span>
                    <span v-else class="sb-nudge-warn">No phone</span>
                </div>

                <div v-if="noPhone.length" class="sb-nudge-msg">
                    {{ listNames(noPhone.map(r => r.Name)) }} {{ noPhone.length == 1 ? 'doesn\'t' : 'don\'t' }} have a phone number, so they won't get a text.
                    Add one to their employee record<template v-if="isAdmin">:
                        <template v-for="(r, i) in noPhone" :key="r.EmployeeID"><router-link :to="'/employee/' + r.EmployeeID">{{ r.Name }}</router-link>{{ i < noPhone.length - 1 ? ', ' : '' }}</template></template>.
                </div>
                <div v-if="unowned" class="sb-nudge-msg">
                    {{ unowned }} metric{{ unowned == 1 ? ' has' : 's have' }} no owner, so no one gets reminded about {{ unowned == 1 ? 'it' : 'them' }}.
                </div>
            </template>

            <div class="sb-actions">
                <span style="flex:1"></span>
                <div class="btn-light" @click="$emit('close')">Cancel</div>
                <div v-if="texted.length" class="btn" :class="sending ? 'disable-button' : ''" @click="send()">Send {{ texted.length }} Text{{ texted.length == 1 ? '' : 's' }}</div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import axios from 'axios';

export default defineComponent({
    name: 'ScoreboardNudgeModal',
    // week: this week's Monday
    props: [ 'team', 'week' ],
    emits: [ 'close', 'sent' ],
    data() {
        return {
            loaded: false,
            recipients: [] as any[],
            unowned: 0,
            sending: false
        }
    },
    async created() {
        await axios.get(`${this.$store.state.apiUrl}/api/scoreboard/nudge`, { params: { team: this.team, week: this.week } })
            .then(resp => {
                this.recipients = resp.data.Recipients;
                this.unowned = resp.data.Unowned;
            })
            .catch(e => {
                console.log(e);
            })
        this.loaded = true;
    },
    computed: {
        texted(): any[] {
            return this.recipients.filter((r: any) => r.HasPhone);
        },
        noPhone(): any[] {
            return this.recipients.filter((r: any) => !r.HasPhone);
        },
        isAdmin(): boolean {
            return this.$store.state.user.teamHubRole == 'Admin';
        }
    },
    methods: {
        listNames(names: string[]): string {
            return names.length > 1 ? names.slice(0, -1).join(', ') + ' and ' + names[names.length - 1] : names[0] || '';
        },
        async send() {
            if(this.sending) {
                return;
            }
            this.sending = true;
            await axios.post(`${this.$store.state.apiUrl}/api/scoreboard/nudge`, { Team: this.team, Week: this.week })
                .then(resp => {
                    this.$emit('sent', resp.data);
                })
                .catch(e => {
                    console.log(e);
                    alert('There was an error sending the reminders');
                })
            this.sending = false;
        }
    }
});
</script>

<style scoped>
.sb-modal-title { margin: 0 0 6px; font-size: 20px; }
.sb-intro { font-size: 13.5px; color: var(--font-dark-gray); margin: 0 0 12px; }
.sb-nudge-row { display: flex; align-items: center; gap: 12px; padding: 10px 0; border-top: 1px solid var(--mid-gray); }
.sb-nudge-l { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 2px; }
.sb-nudge-l b { font-size: 14px; }
.sb-nudge-l span { font-size: 12px; color: var(--font-mid-gray); }
.sb-nudge-ok, .sb-nudge-warn { font-size: 11.5px; font-weight: 700; border-radius: 12px; padding: 3px 10px; white-space: nowrap; }
.sb-nudge-ok { background: #E3F4E8; color: #2E7D46; }
.sb-nudge-warn { background: #FBF0DA; color: #9A6B15; }
.sb-nudge-msg { margin-top: 12px; font-size: 12.5px; color: #9A6B15; background: #FBF0DA; border-radius: 8px; padding: 8px 12px; }
.sb-nudge-msg a { color: inherit; font-weight: 700; text-decoration: underline; }
.sb-actions { display: flex; align-items: center; gap: 10px; margin-top: 20px; }
.sb-actions .btn, .sb-actions .btn-light { margin: 0; padding: 8px 18px; }
</style>
